/**
 * botgpt/conversationApi.js — Sprint 1 refactor (2026-05-20)
 *
 * Trước: dùng REACT_APP_OPENAI_KEY + user_token query param + /stream/free.
 * Sau:   gọi POST /api/v1/llm-gateway/chat/stream qua JWT Authorization header,
 *        backend tự routing tool='botgpt' → Claude Haiku 4.5.
 *
 * Component cũ vẫn gọi `fetchAnswerSteaming(...)` với chữ ký cũ — chúng ta giữ
 * shape (Promise + onEvent MessageEvent) qua adapter `streamChatLegacy`.
 */

import { streamChatLegacy, RateLimitError } from '../_shared/llmGateway';
import { authManager } from 'utils/authManager';

const apiHost = process.env.REACT_APP_API_URL || '/api/v1';
const TOOL = 'botgpt';

/** Non-streaming Q&A (RAG-style). Giữ contract cũ vì document component depend vào. */
export async function fetchAnswerApi(question, _apiKey, selectedDocs, history = [], conversationId) {
    // RAG path qua backend /api/answer — JWT thay api_key/user_token.
    const auth = authManager.getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (auth) headers.Authorization = `Bearer ${auth}`;

    const cleanHistory = history.map((item) => ({ prompt: item.prompt, response: item.response }));

    const res = await fetch(`${apiHost}/answer`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
            question,
            history: cleanHistory,
            selected_docs: selectedDocs,
            conversation_id: conversationId,
            project: TOOL,
        }),
    });
    if (!res.ok) throw new Error(res.statusText || 'fetchAnswerApi failed');
    const data = await res.json();
    return {
        answer: data.answer,
        query: question,
        result: data.answer,
        sources: data.sources,
        conversationId: data.conversation_id,
    };
}

/**
 * Streaming chat qua LLM Gateway.
 * @param {string} question
 * @param {string} [model]  - DEPRECATED, gateway tự route (giữ tham số để component cũ pass được)
 * @param {string} [_apiKey] - DEPRECATED, bỏ qua (server-side)
 * @param {Object} [_selectedDocs] - unused trong gateway (RAG path qua fetchAnswerApi)
 * @param {Array}  [history]
 * @param {string} [_conversationId]
 * @param {Function} onEvent - (MessageEvent) => void (legacy)
 * @param {Object} [opts]
 * @param {AbortSignal} [opts.signal]
 * @param {string} [opts.systemPrompt]
 */
export function fetchAnswerSteaming(
    question,
    model,
    _apiKey,
    _selectedDocs,
    history = [],
    _conversationId,
    onEvent,
    opts = {}
) {
    return streamChatLegacy({
        tool: TOOL,
        question,
        history,
        model,
        systemPrompt: opts.systemPrompt,
        signal: opts.signal,
        onEvent,
    }).catch((e) => {
        if (e instanceof RateLimitError) {
            // Component có thể bắt qua window listener hoặc try/catch ngoài.
            onEvent?.(new MessageEvent('message', { data: JSON.stringify({ type: 'error', detail: e.message, tool: TOOL, status: 429 }) }));
        }
        throw e;
    });
}

export async function sendFeedback(prompt, response, feedback) {
    const auth = authManager.getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (auth) headers.Authorization = `Bearer ${auth}`;
    const res = await fetch(`${apiHost}/feedback`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ question: prompt, answer: response, feedback, project: TOOL }),
    });
    if (!res.ok) throw new Error('sendFeedback failed');
}
